module.exports = __webpack_public_path__ + "img/3gp.2a176190.svg";